/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import ViewButton from '../../UI/button/button';
import MisCardList from './misCardList';
import { MisCardLine, CardsHeader } from './styles';
import { IRNComplianceSummary } from '../../../common/types';
import { useGlobalState } from '../../context/qrState';
import { track } from '../../../analytics/analytics';
import { EventIDs } from '../../../analytics/events';
import { UserContext } from '../../context/userContext';

interface MisCardsProps {
  cardsData: IRNComplianceSummary[];
}

const MISCards: React.FC<MisCardsProps> = ({ cardsData }) => {
  let gstinsNumber = 0;
  if (
    cardsData.length !== 0 &&
    cardsData[0].orgId
  ) {
    gstinsNumber = cardsData.length;
  }
  const history = useHistory();
  const [pageNumber, setPageNumber] = useGlobalState('pageNumber');
  const { email } = useContext<Record<string, any>>(UserContext);

  const viewButtonClickHandler = () => {
    history.push('/inv');
    setPageNumber(0);
    const payload = {
      email,
    };
    track(EventIDs.VIEW_INVOICES_CLICK, payload);
  };

  return (
    <>
      <ViewButton buttonText="Invoices" clicked={viewButtonClickHandler} />
      <MisCardLine />
      <CardsHeader>IRN Compliance for {gstinsNumber} GSTINs:</CardsHeader>
      {gstinsNumber !== 0 && <MisCardList childCardsData={cardsData} />}
    </>
  );
};

export default MISCards;
